import type { ReactNode } from 'react'
import React, { forwardRef } from 'react'

import type { Alignmentype, Width } from '../../../themes/types'
import { StyledFlex } from './Flex.styles'

export interface FlexProps {
  'data-e2e'?: string
  alignment?: Alignmentype
  /** @deprecated use alignment prop instead */
  center?: boolean
  children?: ReactNode
  className?: string
  fluid?: boolean
  gap?: Width
  wrap?: boolean
}

const Flex = forwardRef<HTMLDivElement, FlexProps>(({ children, wrap = false, ...props }, ref) => (
  <StyledFlex ref={ref} {...props} $wrap={wrap}>
    {children}
  </StyledFlex>
))

export default Flex
